import {useSequenceValidation} from '@/modules/patients-therapies/hooks'
import {Box, Button, ButtonGroup, HStack, Text} from '@chakra-ui/react'
import {PatientTherapySequence} from '@cypro/engine/schema'
import {DialogBody, DialogFooter, DialogHeader} from '@cypro/ui/components'
import {getDatetimeFormatter} from '@cypro/ui/utils'
import {useTranslate} from '@tolgee/react'
import {closeReversePatientArrivedDialog} from './util'

export function ReversePatientArrivedDialog({sequence}: {sequence: PatientTherapySequence}) {
  const {t} = useTranslate('common')
  const {onReversePatientArrival} = useSequenceValidation(sequence)

  return (
    <>
      <DialogHeader description={t('reverse_patient_arrived.description')}>
        {t('reverse_patient_arrived.title')}
      </DialogHeader>

      <DialogBody minHeight="none">
        <Box
          borderWidth="1px"
          borderColor="border"
          borderRadius="md"
          bg="bg.subtle"
          paddingX="3"
          paddingY="2"
          spaceY="2"
        >
          <SummaryLine label={t('order')} value={sequence.internalId} />
          <SummaryLine
            label={t('patient_arrived')}
            value={sequence.patientArrivedAt ? getDatetimeFormatter().format(sequence.patientArrivedAt) : null}
          />
        </Box>
      </DialogBody>

      <DialogFooter>
        <ButtonGroup size="md" width="100%" justifyContent="flex-end">
          <Button variant="outline" colorPalette="gray" onClick={closeReversePatientArrivedDialog}>
            {t('cancel')}
          </Button>
          <Button colorPalette="cyan" onClick={onReversePatientArrival}>
            {t('reverse')}
          </Button>
        </ButtonGroup>
      </DialogFooter>
    </>
  )
}

function SummaryLine({label, value}: {label: string; value?: string | null}) {
  return (
    <HStack alignItems="baseline">
      <Text textStyle="xs" color="fg.muted">
        {label}
      </Text>
      <Text textStyle="xs" fontWeight="medium">
        {value || '-'}
      </Text>
    </HStack>
  )
}
